import React, { useEffect, useState } from "react";
import { apiRequest, EPISODE_LIST_URL } from "../../utils/Helper";

const Footer = ({ episodeData }) => {
  const [episodeListData, setEpisodeListData] = useState();
  const handleEpisodeClick = (id) => {
    window.location.href = `/parikshapecharcha2025/allepisode/${id}`;
  };

  useEffect(() => {
    const fetchEpisodeListData = async () => {
      try {
        const response = await apiRequest(EPISODE_LIST_URL);
        if (response && response.data.length > 0) {
          setEpisodeListData(response?.data);
        }
      } catch (error) {
        console.error("Failed to fetch episode list data:", error);
      }
    };

    fetchEpisodeListData();
  }, []);

  return (
    <>
      <section className="footer_sec">
        <div className="container-fluid">
          <div className="sunder_con_pad">
            <div className="row">
              <div className="col-md-4">
                <img
                  className="foote_logo"
                  src="/assets/vimages/parikshapecharcha_logo.svg"
                  alt=""
                />
              </div>

              <div className="col-md-5">
                <label> All Episodes</label>
                <div className="row">
                  <div className="col">
                    <ul className="episode_list">
                      {episodeListData &&
                        episodeListData.length > 0 &&
                        episodeListData.map((val) => {
                          return (
                            <li>
                              <a onClick={() => handleEpisodeClick(val.id)}>
                                Episode {val.sequence}
                              </a>
                            </li>
                          );
                        })}

                      {/* <li>
                        <a onClick={() => handleEpisodeClick(2)}>Episode 2</a>
                      </li>
                      <li>
                        <a onClick={() => handleEpisodeClick(3)}>Episode 3</a>
                      </li>
                      <li>
                        <a onClick={() => handleEpisodeClick(4)}>Episode 4</a>
                      </li>
                      <li>
                        <a onClick={() => handleEpisodeClick(5)}>Episode 5</a>
                      </li>
                      <li>
                        <a onClick={() => handleEpisodeClick(6)}>Episode 6</a>
                      </li>
                      <li>
                        <a onClick={() => handleEpisodeClick(7)}>Episode 7</a>
                      </li> */}
                    </ul>
                  </div>
                  {/* <div className="col">
                    <ul>
                      <li style={{ cursor: "pointer" }}>
                        <a onClick={() => handleEpisodeClick(5)}>Episode 5</a>
                      </li>
                      <li style={{ cursor: "pointer" }}>
                        <a onClick={() => handleEpisodeClick(6)}>Episode 6</a>
                      </li>
                      <li style={{ cursor: "pointer" }}>
                        <a onClick={() => handleEpisodeClick(7)}>Episode 7</a>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </div>
              {/* <div className="col-md-3">
                <label> Quick Links</label>
                <ul>
                  <li>
                    <a href="#">TransformingIndia</a>
                  </li>
                  <li>
                    <a href="#">MyGov Blog</a>
                  </li>
                  <li>
                    <a href="#">MyGov Quiz</a>
                  </li>
                  <li>
                    <a href="#">MyGov</a>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      <div className="copyline_ft">
        <div className="container-fluid">
          <div className="sunder_con_pad">
            <div className="copyline_col">
              <div>@ Copyright 2025 Pariksha Pe Charcha</div>
              {/* <div className="social_icons">
                <a href="#">
                  <img src="/assets/vimages/fb_icon.svg" alt="Facebook" />
                </a>
                <a href="#">
                  <img src="/assets/vimages/x_icon.svg" alt="X" />
                </a>
                <a href="#">
                  <img src="/assets/vimages/insta_icon.svg" alt="Instagram" />
                </a>
                <a href="#">
                  <img src="/assets/vimages/yt_icon.svg" alt="YouTube" />
                </a>
                <a href="#">
                  <img src="/assets/vimages/pin_icon.svg" alt="Pinterest" />
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
